export default "__VITE_ASSET__D8bazpA1__"